import Kanban from '@/components/kanban';
import ColabKanban from '@/components/kanban/collab';
import { TokenPayload } from '@/components/navbar/tabs/MenuTabs';
import { getTokenFromStorage } from '@/utils/getToken';
import { jwtDecode } from 'jwt-decode';
import React, { useEffect, useState } from 'react';
export default function DashboardPage() {
  const [isAdmin, setIsAdmin] = useState(false); // ✅ Topo do componente

  useEffect(() => {
    const checkToken = () => {
      const token = getTokenFromStorage();
      if (!token) return;

      try {
        const decodedToken = jwtDecode<TokenPayload>(token);
        if (decodedToken.roles.includes('admin')) {
          setIsAdmin(true);
        }
      } catch (error) {
        console.error("Erro ao decodificar token:", error);
      }
    };

    checkToken();
  }, []); // ✅ Executa só uma vez

  return (
    <div className='mt-w-full mt-6 bg-indigo-200'> 
      <div className="grid grid-cols-1 pr-2 min-h-screen bg-indigo-200">
        {isAdmin ? <Kanban /> : <ColabKanban />}
      </div> 
    </div>
  );
}
